<template>
    <v-dialog
    v-model="$store.state.payroll.modalUncharged"
    min-width="1366"
    max-width="1600"
  
>
    <v-card>
        <v-toolbar dense color="primary">
            <v-spacer></v-spacer>
            <v-toolbar-title dense class="white--text"
                >Uncharged Fuel</v-toolbar-title
            >
            <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.payroll.modalUncharged = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
        </v-toolbar>
        <v-container grid-list-xs fluid>
            <v-data-table
                :headers="headers"
                :items="uncharged"
                hide-actions
                hide-details
                disable-sort
                dense
            >
            <template v-slot:top>
                <v-row justify="end">
                    <v-col cols="1">
                        <v-btn @click="downloadExcel" icon> Export <v-icon color="success">mdi-microsoft-excel</v-icon></v-btn>
                    </v-col>
                </v-row>
            </template>
            </v-data-table>
        </v-container>
    </v-card>
</v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    name: 'Fuel',
    data: function() {
        return {
            headers:[
                { text: 'Stid', value: 'Stid', width: '1%' },
                { text: 'rStId', value: 'rStId', width: '1%' },
                { text: 'ShiftDetail', value: 'ShiftDetail', width: '1%' },
                { text: 'Truck', value: 'Truck', width: '1%' },
                { text: 'Date', value: 'Date', width: '30%' },
                { text: 'Type', value: 'Type', width: '1%' },
                { text: 'Supplier', value: 'Supplier', width: '1%' },
                { text: 'GST', value: 'GST', width: '1%' },
                { text: 'Total', value: 'Total', width: '1%' },
                { text: 'InvoiceNo', value: 'InvoiceNo', width: '1%' },
                { text: 'Price', value: 'Price', width: '1%' },
                { text: 'TractorIDText', value: 'TractorIDText', width: '1%' },
                { text: 'ActualPrice', value: 'ActualPrice', width: '1%' },
                { text: 'ActualCost', value: 'ActualCost', width: '1%' },
                { text: 'Supplier Invoice Date', value: 'SupplierInvoiceDate', width: '25%' },
                { text: 'TranDate', value: 'TranDate', width: '1%' }
            ],
            uncharged:[],
        };
    },
    mounted() {
        this.loadUncharged();
    },
    methods: {
       loadUncharged: function(){
        var str = this.$store;
        str.state.isLoading = true;
        var parms = {
            StartDate : this.$store.state.payroll.StartDate,
            EndDate: this.$store.state.payroll.EndDate,
            Export: false,
        }
             axios
                 .post('fuel-expense/uncharged/fuel', parms, {
                     headers: {
                         Authorization: 'Bearer ' + this.$store.state.token
                     }
                 })
                 .then(response => {
                     console.log(response.data);
                     this.uncharged = response.data;
                     str.state.isLoading = false;
                 })
                 .catch(error => {
                     str.state.isLoading = false;
                     this.$store.dispatch('setSnackbar', {
                         color: 'error',
                         text: 'An error has ocurred, please try again.'
                     });
                     console.log(error);
                 });
       },
       downloadExcel: async function() {
            var str = this.$store;
            var parms = {
                StartDate : this.$store.state.payroll.StartDate,
                EndDate: this.$store.state.payroll.EndDate,
                Export: true,
            }
            str.state.isLoading = true;
            axios
                .post('fuel-expense/uncharged/fuel' ,parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Uncharged-Fuel.xlsx');
                    document.body.appendChild(link);
                    link.click();
                     str.state.isLoading = false;
                })
                .catch(function(error) {
                     str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
    }
};
</script>
